import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20golden%20and%20cream%20gradient%20background%20with%20flowing%20geometric%20shapes%20and%20soft%20curves%2C%20minimalist%20modern%20design%2C%20elegant%20navigation%20concept%2C%20luxurious%20and%20trustworthy%20atmosphere%2C%20no%20text%20no%20people%2C%20high%20quality%20abstract%20art&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt="www91官方导航背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
            <i className="ri-verified-badge-line text-primary-400 text-sm w-4 h-4 flex items-center justify-center"></i>
            <span className="text-background-50/90 text-xs font-medium">官方认证导航站点</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5">
            www91官方入口
            <br />
            <span className="text-primary-400">安全稳定访问</span>
          </h1>

          <p className="text-background-100/80 text-base md:text-lg max-w-[640px] mx-auto mb-8 leading-relaxed">
            www91是广受用户信赖的网络平台，本导航站提供www91最新官方入口地址、访问指南及常见问题解答，帮助您快速找到正确地址，收藏本页永不迷路。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://www91.com"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-full sm:w-auto px-8 py-3.5 rounded-xl bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-external-link-line w-4 h-4 flex items-center justify-center"></i>
              访问官方入口
            </a>
            <Link
              to="/category/access-guide"
              className="w-full sm:w-auto px-8 py-3.5 rounded-xl bg-background-50/10 hover:bg-background-50/20 backdrop-blur-sm border border-background-50/25 text-background-50 font-medium text-sm transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-guide-line w-4 h-4 flex items-center justify-center"></i>
              查看访问指南
            </Link>
          </div>

          <div className="mt-10 flex items-center justify-center gap-8">
            <div className="text-center">
              <p className="font-label text-2xl md:text-3xl font-bold text-background-50">50万+</p>
              <p className="text-background-300 text-xs mt-1">累计用户</p>
            </div>
            <div className="w-px h-10 bg-background-50/15"></div>
            <div className="text-center">
              <p className="font-label text-2xl md:text-3xl font-bold text-background-50">99.9%</p>
              <p className="text-background-300 text-xs mt-1">服务可用率</p>
            </div>
            <div className="w-px h-10 bg-background-50/15"></div>
            <div className="text-center">
              <p className="font-label text-2xl md:text-3xl font-bold text-background-50">24h</p>
              <p className="text-background-300 text-xs mt-1">地址更新</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}